import { z } from "../../../constants/zod";

export const customerSchema = z.object({
	firstname: z.string(),
	lastname: z.string(),
	email: z.string().optional(),
	notes: z.string().optional(),
	address: z.string().optional(),
	phone: z.string().optional(),
	// Only for a business customer: printed on their invoices.
	companyName: z.string().nullable().optional(),
	registrationNumber: z.string().nullable().optional(),
	vatNumber: z.string().nullable().optional(),
});

export type customerSchemaType = z.infer<typeof customerSchema>;
